import { render } from "./overlay.vue?vue&type=template&id=2b915963"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__